import React, { useEffect, useState } from 'react'
import { TabView, TabPanel } from 'primereact/tabview'
import { Tab } from '../../models/tab'
import './tabs.scss'

interface LuxTabsProps {
    tabs: Tab[]
    activeTab: number
    onTabChange?: (val: number) => void
    onTabChangeAlert?: boolean
    key?: string
}

const LuxTabs = (props: LuxTabsProps) => {
    const { tabs, activeTab, onTabChange, onTabChangeAlert }: LuxTabsProps =
        props

    const [visibleTabs, setVisibleTabs] = useState<Tab[]>([])
    const [activeIndex, setActiveIndex] = useState(0)

    useEffect(() => {
        setActiveIndex(activeTab)
    }, [activeTab])

    useEffect(() => {
        if (tabs) {
            setVisibleTabs(tabs)
            if (tabs?.length > 0) {
                let tmpVisibleTabs = []
                let areThereHiddenTabs = false
                for (let i = 0; i < tabs.length; i++) {
                    let tab = tabs[i]
                    if (tab?.hidden && tab?.hidden === true) {
                        areThereHiddenTabs = true
                    } else {
                        tmpVisibleTabs.push(tab)
                    }
                }
                if (areThereHiddenTabs) {
                    setVisibleTabs(tmpVisibleTabs)
                }
            }
        }
    }, [tabs])

    return visibleTabs?.length > 0 ? (
        <div className="wardrobe-tabs">
            <div className="card" data-length={visibleTabs.length}>
                <TabView
                    key={props.key}
                    className="tabview"
                    activeIndex={activeIndex}
                    onTabChange={(e) => {
                        if (!onTabChangeAlert) {
                            setActiveIndex(e.index)
                        }
                        onTabChange && onTabChange(e.index)
                    }}>
                    {visibleTabs.map((tab: Tab, index) => {
                        let tabHeader = (
                            <div>
                                {tab.number && (
                                    <span className="tab-number">
                                        {tab.number}
                                    </span>
                                )}
                                {tab.name}
                                {tab.count ? ' (' + tab.count + ')' : ''}
                            </div>
                        )
                        return (
                            <TabPanel
                                key={index}
                                header={tabHeader}
                                disabled={tab.disabled}
                                leftIcon={tab.iconClasses}
                                headerTemplate={tab.headerTemplate}>
                                {tab.content}
                            </TabPanel>
                        )
                    })}
                </TabView>
            </div>
        </div>
    ) : (
        'There are no tabs.'
    )
}

export default LuxTabs
